export const setStyle = (canvas, width, stroke, fill) => {
  canvas.lineWidth = width
  canvas.strokeStyle = stroke
  canvas.fillStyle = fill
}

export const drawDot = (canvas, x, y, radius) => {
  canvas.beginPath()
  canvas.arc(x, y, radius, 0, 2 * Math.PI)
  canvas.fill()
  canvas.closePath()
}

export const drawCircle = (canvas, x, y, radius) => {
  canvas.beginPath()
  canvas.arc(x, y, radius, 0, 2 * Math.PI)
  canvas.stroke()
  canvas.closePath()
}

export const drawTriangle = function (canvas, point, sideLength, dot) {
  const [x, y] = point

  const pointsOfTriangle = [
    [0, ((1 - Math.sqrt(3)) / 2) * sideLength - sideLength / 5],
    [0.5 * sideLength, 0.5 * sideLength - sideLength / 5],
    [-0.5 * sideLength, 0.5 * sideLength - sideLength / 5],
    [0, ((1 - Math.sqrt(3)) / 2) * sideLength - sideLength / 5],
  ]

  const shiftedTriangle = pointsOfTriangle.map((point) => [
    point[0] + x,
    point[1] + y,
  ])

  canvas.moveTo(...shiftedTriangle[0])
  canvas.beginPath()
  shiftedTriangle.map((point) => canvas.lineTo(...point))
  canvas.stroke()
  canvas.closePath()

  if (dot) drawDot(canvas, x, y, 2)
}

export const drawControlCircle = (canvas, x, y, dot = false) => {
  if (dot) drawDot(canvas, x, y, 2)
  drawCircle(canvas, x, y, 24)
}

export const drawControlNumber = (canvas, x, y, number) => {
  canvas.font = 'bold 32px sans-serif'

  canvas.fillText(number, x + 24, y - 16)
  canvas.strokeText(number, x + 24, y - 16)
}

export const drawPath = (canvas, path) => {
  canvas.moveTo(...path[0])
  canvas.beginPath()
  path.map((point) => canvas.lineTo(...point))
  canvas.stroke()
  canvas.closePath()
}

export const drawFlag = (canvas, x, y) => {
  const flagBg = new Path2D()
  flagBg.rect(x - 4, y - 4, 8, 8)

  const flag = new Path2D()
  flag.moveTo(x - 4, y - 4)
  flag.lineTo(x + 4, y + 4)
  flag.lineTo(x - 4, y + 4)

  canvas.fillStyle = 'white'
  canvas.fill(flagBg)

  canvas.fillStyle = 'orange'
  canvas.fill(flag)
}

export const drawCurve = (canvas, start, control, end) => {
  canvas.beginPath()
  canvas.moveTo(start.x, start.y)
  canvas.quadraticCurveTo(control.x, control.y, end.x, end.y)
  canvas.stroke()
}
